const statisticsDarkInit = () => {
  const mainPattern = document.querySelectorAll('.gg-statistics-light');
  mainPattern.forEach((module) => {
    const container = module.querySelector('.wp-block-columns');
    if (container) {
      const items = container.querySelectorAll('.wp-block-column');
      items.forEach((item, index) => {
        item.classList.add('fade-in-up', `delay-${index}`);
      });
      if (items.length > 3) {
        container.style.setProperty('justify-content', 'start');
      }
    }
  });
};

statisticsDarkInit();